module.exports = __webpack_public_path__ + "img/liveNum1.c6a86a77.png";